module.exports = {"140429100":"丰州镇","140429101":"洪水镇","140429102":"蟠龙镇","140429103":"监漳镇","140429104":"故城镇","140429200":"墨镫乡","140429201":"韩北乡","140429202":"大有乡","140429203":"贾豁乡","140429204":"故县乡","140429205":"上司乡","140429206":"石北乡","140429207":"涌泉乡","140429208":"分水岭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140429.json
// module id = 265
// module chunks = 0